export const fancyHourFormatter = (startTime, endTime) => {
  const formatTime = (date) => {
    if (!date || isNaN(date.getTime())) return "--:--";
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const startDate = startTime != null ? new Date(startTime) : new Date(NaN);
  const endDate = endTime != null ? new Date(endTime) : new Date(NaN);

  const startTimeString = formatTime(startDate);
  const endTimeString = formatTime(endDate);

  return { startTimeString, endTimeString };
};
